(() => {
  'use strict';
  if (window.tdtSeatmapFeedback) return;
  window.tdtSeatmapFeedback = true;
  const copy = window.tdtSeatmapCopy;
  if (!copy || !window.tdtPurchase) return;
  const readyFrames = new WeakSet();
  const watchedFrames = new WeakSet();
  const watchedDocuments = new WeakSet();
  const retryKey = 'tdt-seatmap-retry:' + location.pathname;
  let dialog, message, spinner, retry, close, activeModal, returnFocus, timer, observer, poll;
  let pending = false;
  function getModal() {
    return document.querySelector('.seating-app-smmodal[data-smmodal-id="' + copy.productId + '"]');
  }
  function stopTimer() { clearTimeout(timer); clearInterval(poll); }
  function hideStatus() {
    stopTimer();
    if (dialog?.open) dialog.close();
  }
  function dismiss() {
    pending = false;
    hideStatus();
    activeModal?.classList.remove('active');
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  }
  function showError() {
    if (!pending || !dialog?.open) return;
    clearInterval(poll);
    spinner.hidden = true;
    message.textContent = window.tdtPurchase.copy.seatmap_slow;
    retry.hidden = false;
    dialog.setAttribute('aria-busy', 'false');
  }
  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.id = 'tdt-seatmap-feedback';
    dialog.setAttribute('aria-label', copy.title);
    dialog.innerHTML = '<button type="button" class="tdt-seatmap-close"></button><div class="tdt-seatmap-status"><span class="tdt-seatmap-spinner" aria-hidden="true"></span><p role="status" aria-live="polite"></p><button type="button" class="tdt-seatmap-retry" hidden></button></div>';
    close = dialog.querySelector('.tdt-seatmap-close');
    close.textContent = '×';
    close.setAttribute('aria-label', copy.close);
    message = dialog.querySelector('[role="status"]');
    spinner = dialog.querySelector('.tdt-seatmap-spinner');
    retry = dialog.querySelector('.tdt-seatmap-retry');
    retry.textContent = copy.retry;
    const viewMap = document.createElement('button');
    viewMap.type = 'button';
    viewMap.className = 'tdt-seatmap-retry';
    viewMap.textContent = window.tdtPurchase.copy.view_map;
    viewMap.addEventListener('click', () => {
      pending = false;
      hideStatus();
      activeModal?.querySelector('[data-smmodal-close]')?.focus({ preventScroll: true });
    });
    dialog.querySelector('.tdt-seatmap-status').appendChild(viewMap);
    retry.textContent = window.tdtPurchase.copy.reload;
    close.addEventListener('click', dismiss);
    dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
    retry.addEventListener('click', () => {
      retry.disabled = true;
      message.textContent = copy.reloading;
      try { sessionStorage.setItem(retryKey, String(Date.now())); } catch (_) {}
      location.reload();
    });
    document.body.appendChild(dialog);
  }
  function complete(frame) {
    readyFrames.add(frame);
    if (!pending || !activeModal?.contains(frame)) return;
    pending = false;
    hideStatus();
    activeModal.querySelector('[data-smmodal-close]')?.focus({ preventScroll: true });
  }
  function watchFrame(frame) {
    if (watchedFrames.has(frame)) return;
    watchedFrames.add(frame);
    const attach = () => { try {
      const view = frame.contentWindow;
      const doc = frame.contentDocument;
      if (!doc) return;
      if (!watchedDocuments.has(doc)) {
        watchedDocuments.add(doc);
        view.addEventListener('message', event => {
          if (event.source !== view || event.data?.type !== 'onMapReady') return;
          complete(frame);
        });
      }
      if (view.performance.getEntriesByName('initEnd').length && frame.contentDocument.querySelector('.seatselector canvas')) complete(frame);
    } catch (_) {} };
    frame.addEventListener('load', () => { readyFrames.delete(frame); attach(); });
    attach();
  }
  function activate(modal) {
    activeModal = modal;
    document.documentElement.style.setProperty('--vh', window.innerHeight / 100 + 'px');
    if (!modal.classList.contains('active')) modal.classList.add('active');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', copy.title);
    modal.querySelector('[data-smmodal-close]')?.setAttribute('aria-label', copy.close);
  }
  function refresh() {
    const modal = getModal();
    if (!modal) return;
    if (pending && activeModal !== modal) activate(modal);
    const frame = modal.querySelector('iframe.vivenu-seating-iframe-chart');
    if (frame) {
      watchFrame(frame);
      try {
        if (frame.contentWindow.performance.getEntriesByName('initEnd').length && frame.contentDocument?.querySelector('.seatselector canvas')) complete(frame);
      } catch (_) {}
      if (pending && readyFrames.has(frame)) complete(frame);
    }
  }
  function open(trigger) {
    if (pending) return;
    returnFocus = trigger;
    pending = true;
    ensureDialog();
    spinner.hidden = false;
    retry.hidden = true;
    retry.disabled = false;
    message.textContent = copy.loading;
    dialog.setAttribute('aria-busy', 'true');
    const modal = getModal();
    if (modal) activate(modal);
    refresh();
    if (!pending) return;
    dialog.showModal();
    close.focus({ preventScroll: true });
    timer = setTimeout(showError, 20000);
    poll = setInterval(refresh, 250);
  }
  window.addEventListener('message', event => {
    const frame = getModal()?.querySelector('iframe.vivenu-seating-iframe-chart');
    if (frame && event.source === frame.contentWindow && event.data?.type === 'onMapReady') complete(frame);
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const trigger = target?.closest('[data-open-seatmap], [data-smmodal-open]');
    if (trigger) {
      const root = trigger.closest('.tdt-ticket');
      if (root?.querySelector('.ga-inline-booking')) return;
      const opener = trigger.matches('[data-smmodal-open]') ? trigger : root?.querySelector('[data-smmodal-open]');
      if (!opener && !getModal()) return;
      if (opener && opener.getAttribute('data-smmodal-open') !== String(copy.productId)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      root?.querySelectorAll('video').forEach(video => video.pause());
      open(trigger);
      return;
    }
    if (target?.closest('[data-smmodal-close]') && target.closest('.seating-app-smmodal') === activeModal) dismiss();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && activeModal?.classList.contains('active') && !dialog?.open) {
      event.preventDefault();
      dismiss();
    }
  });
  function start() {
    observer = new MutationObserver(refresh);
    observer.observe(document.body, { childList: true, subtree: true });
    refresh();
    try {
      const saved = Number(sessionStorage.getItem(retryKey));
      sessionStorage.removeItem(retryKey);
      if (saved && Date.now() - saved < 60000) {
        const opener = document.querySelector('[data-smmodal-open="' + copy.productId + '"]');
        if (opener) open(document.querySelector('[data-open-seatmap]') || opener);
      }
    } catch (_) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

